module.exports = __webpack_public_path__ + "static/investmentsIcon-791f9699403553206cee16f85384b184.png";